import { useState } from 'react';

const faqs = [
  {
    q: '6789影院的综艺节目都是免费的吗？',
    a: '是的！6789影院所有综艺节目完全免费在线观看，无需注册、无需会员、无需付费。我们致力于为广大综艺爱好者提供最便捷的免费观看体验，高清画质、流畅不缓冲，随时随地畅享精彩综艺内容。',
  },
  {
    q: '综艺节目的更新速度如何？',
    a: '6789影院坚持每日更新，紧跟各大平台的播出节奏。热门综艺节目播出后，我们会在最短时间内完成更新，确保您不错过任何精彩内容。综艺节目大全涵盖爆笑综艺、音乐选秀、真人秀、谈话节目、竞技综艺、旅行综艺等多种类型。',
  },
  {
    q: '观看综艺节目需要安装播放器吗？',
    a: '不需要！6789影院采用先进的在线播放技术，兼容主流浏览器。您只需要使用Chrome、Safari、Edge等现代浏览器，即可即点即播，无需安装任何插件或播放器。我们采用高效的视频编码方案，确保高清画质的同时保持流畅播放。',
  },
  {
    q: '6789影院支持哪些设备观看？',
    a: '6789影院全面支持桌面电脑、笔记本电脑、平板电脑和智能手机等多种设备。我们的网站采用响应式设计，能够自动适配不同屏幕尺寸，让您在任何设备上都能获得最佳的观看体验。无论是在家、办公室还是通勤路上，综艺节目随您畅享。',
  },
  {
    q: '如果遇到播放卡顿或缓冲问题怎么办？',
    a: '6789影院的视频播放引擎经过深度优化，通常情况下可以保证流畅播放不缓冲。如果遇到卡顿，建议您：1) 检查网络连接是否稳定；2) 尝试刷新页面；3) 清除浏览器缓存；4) 切换至较低清晰度。如果问题持续存在，欢迎通过"关于我们"页面的联系方式与我们取得联系。',
  },
  {
    q: '6789影院的综艺节目资源从哪里来？',
    a: '6789影院通过合法合规的渠道收录全网优质综艺节目资源。我们与多家内容平台保持合作关系，致力于为用户提供最全面、最及时的综艺节目大全。我们严格遵守相关法律法规，尊重知识产权，为用户打造安全可靠的免费综艺观看平台。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="px-4 md:px-6 py-10 md:py-14" aria-label="常见问题">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于6789影院的常见疑问，这里都有答案</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-5 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
                aria-expanded={openIndex === index}
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}